(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

     document.addEventListener("DOMContentLoaded", function () {
    const productTitle = document.getElementById("details-product-title");
    const mobileContainer = document.getElementById("mobile-product-title");

    // Create a placeholder to return element to original position
    const placeholder = document.createElement("span");
    placeholder.style.display = "none";

    // Store original parent and insert placeholder
    const originalParent = productTitle.parentElement;
    originalParent.insertBefore(placeholder, productTitle.nextSibling);

    function moveTitle() {
      if (!productTitle || !mobileContainer || !placeholder) return;

      if (window.innerWidth <= 768) {
        if (!mobileContainer.contains(productTitle)) {
          mobileContainer.appendChild(productTitle);
        }
      } else {
        if (!originalParent.contains(productTitle)) {
          originalParent.insertBefore(productTitle, placeholder);
        }
      }
    }

    // Run on load and resize
    moveTitle();
    window.addEventListener("resize", moveTitle);

   });
document.addEventListener('DOMContentLoaded', function () {
  const MAX_CHARS = 100; // count includes spaces
  const nodes = document.querySelectorAll('#tab_des .description');

  nodes.forEach(function(desc) {
    const fullHTML = desc.innerHTML.trim();
    if (!fullHTML) return;

    // Temporary element to manipulate safely
    const temp = document.createElement('div');
    temp.innerHTML = fullHTML;

    let charCount = 0;
    let truncated = false;

    // Walk through text nodes in document order
    const walker = document.createTreeWalker(temp, NodeFilter.SHOW_TEXT, null, false);

    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent;
      const remaining = MAX_CHARS - charCount;

      if (remaining <= 0) {
        node.textContent = '';
        truncated = true;
      } else if (text.length > remaining) {
        node.textContent = text.substring(0, remaining) + '…';
        truncated = true;
        // remove all nodes that follow this
        removeFollowingNodes(node);
        break;
      }

      charCount += text.length;
    }

    if (!truncated) return; // no truncation needed

    const shortDiv = document.createElement('div');
    shortDiv.className = 'short-content';
    shortDiv.innerHTML = temp.innerHTML;

    const fullDiv = document.createElement('div');
    fullDiv.className = 'full-content';
    fullDiv.style.display = 'none';
    fullDiv.innerHTML = fullHTML;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'read-more-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Read more';

    toggle.addEventListener('click', function () {
      const expanded = fullDiv.style.display === 'block';
      fullDiv.style.display = expanded ? 'none' : 'block';
      shortDiv.style.display = expanded ? 'block' : 'none';
      toggle.textContent = expanded ? 'Read more' : 'Show less';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });

    desc.innerHTML = '';
    desc.appendChild(shortDiv);
    desc.appendChild(fullDiv);
    desc.appendChild(toggle);
  });

  function removeFollowingNodes(node) {
    let current = node;
    while (current) {
      if (current.nextSibling) {
        current.parentNode.removeChild(current.nextSibling);
      } else {
        current = current.parentNode;
        if (!current) break;
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  if (!window.location.pathname.includes('/products/av-pros-gift-card')) return;
  if (!window.location.hostname.includes('avpros.co.za')) return;

  const titleLabel = document.querySelector('.title-options .label-selected');
  const optionSection = document.querySelector('.product-options__section');
  if (!titleLabel || !optionSection) return;

  function syncActiveOptionToTitle() {
    let activeLabel = optionSection.querySelector('.product-options__value.active label');

    // Fallback: checked radio
    if (!activeLabel) {
      const checkedRadio = optionSection.querySelector('input[type="radio"]:checked + label');
      if (checkedRadio) activeLabel = checkedRadio;
    }

    // Fallback: selected option in <select>
    if (!activeLabel) {
      const select = optionSection.querySelector('select');
      if (select) activeLabel = select.options[select.selectedIndex];
    }

    if (!activeLabel) return;

    // Clean text
    const text = (activeLabel.textContent || activeLabel.innerText).trim().replace(/\s+/g, ' ');

    // Update title
    titleLabel.textContent = text;
  }

  // Initial sync
  syncActiveOptionToTitle();

  // Debounced sync to prevent multiple rapid updates
  let debounceTimer;
  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncActiveOptionToTitle, 30);
  }

  // Listen to clicks and changes inside the options section
  optionSection.addEventListener('click', scheduleSync);
  optionSection.addEventListener('change', scheduleSync);

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
